import client from '/src/services/client.js';

export default {
    getFunctions: () => client.get('bots/functions'),
}
